// deps
import React, { memo } from "react";

// styles
import {
    ButtonContainer,
    ButtonsWrapper,
    ErrorWidgetContainer,
    SubTitleText,
    TextContainer,
    TitleText,
} from "./styles";
import { FullWidthButton } from "@swiggy-private/dls-web-core/dist/components/FullWidthButton";
import { ITypographyV2 } from "@swiggy-private/dls-web-common/dist/components/types.internal";
import { useEffectOnce } from "@swiggy-private/core-ui";
export interface IErrorWidgetProps {
    pageImpressionEvent?: VoidFunction;
    title: string;
    titleVariant?: keyof ITypographyV2;
    subTitle: string;
    primaryButton?: IButtonProps;
    secondaryButton?: IButtonProps;
    hasCustomPadding?: {
        top?: number;
        bottom?: number;
    };
}

export interface IButtonProps {
    onClick: () => void;
    text: string;
}

const ErrorWidget = ({
    pageImpressionEvent,
    title,
    titleVariant,
    subTitle,
    primaryButton,
    secondaryButton,
    hasCustomPadding,
}: IErrorWidgetProps) => {
    useEffectOnce(() => {
        pageImpressionEvent?.();
    });

    return (
        <ErrorWidgetContainer hasCustomPadding={hasCustomPadding}>
            <TextContainer>
                <TitleText variant={titleVariant || "V2.heading1.neutral.black"}>{title}</TitleText>
                <SubTitleText variant={"V2.body2.neutral.regular"}>{subTitle}</SubTitleText>
            </TextContainer>
            <ButtonsWrapper>
                {secondaryButton?.text && (
                    <ButtonContainer>
                        <FullWidthButton variant="secondary" onClick={secondaryButton.onClick}>
                            {secondaryButton.text}
                        </FullWidthButton>
                    </ButtonContainer>
                )}

                {primaryButton?.text && (
                    <ButtonContainer>
                        <FullWidthButton variant="primary" onClick={primaryButton.onClick}>
                            {primaryButton.text}
                        </FullWidthButton>
                    </ButtonContainer>
                )}
            </ButtonsWrapper>
        </ErrorWidgetContainer>
    );
};
export default memo(ErrorWidget);
